import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { FirebaseAppProvider } from 'reactfire';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'


const firebaseConfig = {
  apiKey: "AIzaSyDD6VNU4lcKNfF2KHMBpw9UcqArRkwPwCQ",
  authDomain: "gameforcrypto.firebaseapp.com",
  projectId: "gameforcrypto",
  storageBucket: "gameforcrypto.appspot.com",
  messagingSenderId: "886168349568",
  appId: "1:886168349568:web:fcd09b89754cf98f01af65",
  measurementId: "G-1KXZDZDTDV"
};

function getLibrary(provider) {
  const library = new Web3Provider(provider)
  library.pollingInterval = 12000
  return library
}

ReactDOM.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <Web3ReactProvider getLibrary={getLibrary}>
     <React.Suspense fallback={<h1>Loading app...</h1>}>
    <App />
    </React.Suspense>
    </Web3ReactProvider>
    </FirebaseAppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
